import moment from 'moment';
import { shallowEqual, useSelector } from 'react-redux';

import {
  selectDetails as selectEmailQuoteDetails,
  selectData as selectEmailQuoteData
} from 'state/email-quote/email-quote-slice';
import { NsAlert } from 'components/common/ns-alert/NsAlert';

export const emailQuoteMsgTestId = 'emailQuoteMsgTestId';

export const QuoteByEmailConfirmationMsg = () => {
  const { email } = useSelector(selectEmailQuoteDetails, shallowEqual);
  const { ExpirationTime: expirationTime } = useSelector(
    selectEmailQuoteData,
    shallowEqual
  );
  const today = moment();
  const mExpirationDate = moment.unix(expirationTime);
  const validity = mExpirationDate.diff(today, 'days');
  const hasReceivedEmail = !!expirationTime;

  if (!hasReceivedEmail) {
    return null;
  }

  return (
    <>
      <NsAlert
        state="success"
        heading="We've sent you an email"
        testId={emailQuoteMsgTestId}
      >
        <p>
          We&apos;ve emailed you at {email}. Follow the link within the email to
          come back later. It&apos;s valid for the next {validity} days.
        </p>
      </NsAlert>
      <br />
    </>
  );
};
